"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.typography = void 0;
const fontFamilies_1 = require("./fontFamilies");
const fontSizes_1 = require("./fontSizes");
const fontWeights_1 = require("./fontWeights");
const letterSpacing_1 = require("./letterSpacing");
const lineHeights_1 = require("./lineHeights");
/* eslint-enable jsdoc/check-property-names, jsdoc/tag-lines */
exports.typography = {
    sDisplayMD: {
        fontFamily: fontFamilies_1.fontFamilies.euclidCircularB,
        fontWeight: fontWeights_1.fontWeights.bold,
        fontSize: fontSizes_1.fontSizes.fontSize7,
        lineHeight: lineHeights_1.lineHeights.lineHeight6,
        letterSpacing: letterSpacing_1.letterSpacing.letterSpacing0,
    },
    sHeadingLG: {
        fontFamily: fontFamilies_1.fontFamilies.euclidCircularB,
        fontWeight: fontWeights_1.fontWeights.bold,
        fontSize: fontSizes_1.fontSizes.fontSize6,
        lineHeight: lineHeights_1.lineHeights.lineHeight5,
        letterSpacing: letterSpacing_1.letterSpacing.letterSpacing0,
    },
    sHeadingMD: {
        fontFamily: fontFamilies_1.fontFamilies.euclidCircularB,
        fontWeight: fontWeights_1.fontWeights.bold,
        fontSize: fontSizes_1.fontSizes.fontSize5,
        lineHeight: lineHeights_1.lineHeights.lineHeight4,
        letterSpacing: letterSpacing_1.letterSpacing.letterSpacing0,
    },
    sHeadingSM: {
        fontFamily: fontFamilies_1.fontFamilies.euclidCircularB,
        fontWeight: fontWeights_1.fontWeights.bold,
        fontSize: fontSizes_1.fontSizes.fontSize4,
        lineHeight: lineHeights_1.lineHeights.lineHeight4,
        letterSpacing: letterSpacing_1.letterSpacing.letterSpacing0,
    },
    /**
     * @deprecated [#1] since version 1.9 [#2].
     * [#3] Will be deleted in version 2.0.
     */
    sHeadingSMRegular: {
        fontFamily: fontFamilies_1.fontFamilies.euclidCircularB,
        fontWeight: fontWeights_1.fontWeights.regular,
        fontSize: fontSizes_1.fontSizes.fontSize4,
        lineHeight: lineHeights_1.lineHeights.lineHeight4,
        letterSpacing: letterSpacing_1.letterSpacing.letterSpacing0,
    },
    sBodyLGMedium: {
        fontFamily: fontFamilies_1.fontFamilies.euclidCircularB,
        fontWeight: fontWeights_1.fontWeights.medium,
        fontSize: fontSizes_1.fontSizes.fontSize4,
        lineHeight: lineHeights_1.lineHeights.lineHeight4,
        letterSpacing: letterSpacing_1.letterSpacing.letterSpacing0,
    },
    sBodyMD: {
        fontFamily: fontFamilies_1.fontFamilies.euclidCircularB,
        fontWeight: fontWeights_1.fontWeights.regular,
        fontSize: fontSizes_1.fontSizes.fontSize3,
        lineHeight: lineHeights_1.lineHeights.lineHeight3,
        letterSpacing: letterSpacing_1.letterSpacing.letterSpacing0,
    },
    sBodyMDMedium: {
        fontFamily: fontFamilies_1.fontFamilies.euclidCircularB,
        fontWeight: fontWeights_1.fontWeights.medium,
        fontSize: fontSizes_1.fontSizes.fontSize3,
        lineHeight: lineHeights_1.lineHeights.lineHeight3,
        letterSpacing: letterSpacing_1.letterSpacing.letterSpacing0,
    },
    sBodyMDBold: {
        fontFamily: fontFamilies_1.fontFamilies.euclidCircularB,
        fontWeight: fontWeights_1.fontWeights.bold,
        fontSize: fontSizes_1.fontSizes.fontSize3,
        lineHeight: lineHeights_1.lineHeights.lineHeight3,
        letterSpacing: letterSpacing_1.letterSpacing.letterSpacing0,
    },
    sBodySM: {
        fontFamily: fontFamilies_1.fontFamilies.euclidCircularB,
        fontWeight: fontWeights_1.fontWeights.regular,
        fontSize: fontSizes_1.fontSizes.fontSize2,
        lineHeight: lineHeights_1.lineHeights.lineHeight2,
        letterSpacing: letterSpacing_1.letterSpacing.letterSpacing0,
    },
    sBodySMMedium: {
        fontFamily: fontFamilies_1.fontFamilies.euclidCircularB,
        fontWeight: fontWeights_1.fontWeights.medium,
        fontSize: fontSizes_1.fontSizes.fontSize2,
        lineHeight: lineHeights_1.lineHeights.lineHeight2,
        letterSpacing: letterSpacing_1.letterSpacing.letterSpacing0,
    },
    sBodySMBold: {
        fontFamily: fontFamilies_1.fontFamilies.euclidCircularB,
        fontWeight: fontWeights_1.fontWeights.bold,
        fontSize: fontSizes_1.fontSizes.fontSize2,
        lineHeight: lineHeights_1.lineHeights.lineHeight2,
        letterSpacing: letterSpacing_1.letterSpacing.letterSpacing0,
    },
    sBodyXS: {
        fontFamily: fontFamilies_1.fontFamilies.euclidCircularB,
        fontWeight: fontWeights_1.fontWeights.regular,
        fontSize: fontSizes_1.fontSizes.fontSize1,
        lineHeight: lineHeights_1.lineHeights.lineHeight1,
        letterSpacing: letterSpacing_1.letterSpacing.letterSpacing1,
    },
    sBodyXSMedium: {
        fontFamily: fontFamilies_1.fontFamilies.euclidCircularB,
        fontWeight: fontWeights_1.fontWeights.medium,
        fontSize: fontSizes_1.fontSizes.fontSize1,
        lineHeight: lineHeights_1.lineHeights.lineHeight1,
        letterSpacing: letterSpacing_1.letterSpacing.letterSpacing1,
    },
    lDisplayMD: {
        fontFamily: fontFamilies_1.fontFamilies.euclidCircularB,
        fontWeight: fontWeights_1.fontWeights.medium,
        fontSize: fontSizes_1.fontSizes.fontSize8,
        lineHeight: lineHeights_1.lineHeights.lineHeight7,
        letterSpacing: letterSpacing_1.letterSpacing.letterSpacing0,
    },
    lHeadingLG: {
        fontFamily: fontFamilies_1.fontFamilies.euclidCircularB,
        fontWeight: fontWeights_1.fontWeights.bold,
        fontSize: fontSizes_1.fontSizes.fontSize7,
        lineHeight: lineHeights_1.lineHeights.lineHeight6,
        letterSpacing: letterSpacing_1.letterSpacing.letterSpacing0,
    },
    lHeadingMD: {
        fontFamily: fontFamilies_1.fontFamilies.euclidCircularB,
        fontWeight: fontWeights_1.fontWeights.bold,
        fontSize: fontSizes_1.fontSizes.fontSize6,
        lineHeight: lineHeights_1.lineHeights.lineHeight5,
        letterSpacing: letterSpacing_1.letterSpacing.letterSpacing0,
    },
    lHeadingSM: {
        fontFamily: fontFamilies_1.fontFamilies.euclidCircularB,
        fontWeight: fontWeights_1.fontWeights.bold,
        fontSize: fontSizes_1.fontSizes.fontSize5,
        lineHeight: lineHeights_1.lineHeights.lineHeight4,
        letterSpacing: letterSpacing_1.letterSpacing.letterSpacing0,
    },
    /**
     * @deprecated [#1] since version 1.9 [#2].
     * [#3] Will be deleted in version 2.0.
     */
    lHeadingSMRegular: {
        fontFamily: fontFamilies_1.fontFamilies.euclidCircularB,
        fontWeight: fontWeights_1.fontWeights.regular,
        fontSize: fontSizes_1.fontSizes.fontSize5,
        lineHeight: lineHeights_1.lineHeights.lineHeight4,
        letterSpacing: letterSpacing_1.letterSpacing.letterSpacing0,
    },
    lBodyLGMedium: {
        fontFamily: fontFamilies_1.fontFamilies.euclidCircularB,
        fontWeight: fontWeights_1.fontWeights.medium,
        fontSize: fontSizes_1.fontSizes.fontSize5,
        lineHeight: lineHeights_1.lineHeights.lineHeight4,
        letterSpacing: letterSpacing_1.letterSpacing.letterSpacing0,
    },
    lBodyMD: {
        fontFamily: fontFamilies_1.fontFamilies.euclidCircularB,
        fontWeight: fontWeights_1.fontWeights.regular,
        fontSize: fontSizes_1.fontSizes.fontSize4,
        lineHeight: lineHeights_1.lineHeights.lineHeight4,
        letterSpacing: letterSpacing_1.letterSpacing.letterSpacing0,
    },
    lBodyMDMedium: {
        fontFamily: fontFamilies_1.fontFamilies.euclidCircularB,
        fontWeight: fontWeights_1.fontWeights.medium,
        fontSize: fontSizes_1.fontSizes.fontSize4,
        lineHeight: lineHeights_1.lineHeights.lineHeight4,
        letterSpacing: letterSpacing_1.letterSpacing.letterSpacing0,
    },
    lBodyMDBold: {
        fontFamily: fontFamilies_1.fontFamilies.euclidCircularB,
        fontWeight: fontWeights_1.fontWeights.bold,
        fontSize: fontSizes_1.fontSizes.fontSize4,
        lineHeight: lineHeights_1.lineHeights.lineHeight4,
        letterSpacing: letterSpacing_1.letterSpacing.letterSpacing0,
    },
    lBodySM: {
        fontFamily: fontFamilies_1.fontFamilies.euclidCircularB,
        fontWeight: fontWeights_1.fontWeights.regular,
        fontSize: fontSizes_1.fontSizes.fontSize3,
        lineHeight: lineHeights_1.lineHeights.lineHeight3,
        letterSpacing: letterSpacing_1.letterSpacing.letterSpacing0,
    },
    lBodySMMedium: {
        fontFamily: fontFamilies_1.fontFamilies.euclidCircularB,
        fontWeight: fontWeights_1.fontWeights.medium,
        fontSize: fontSizes_1.fontSizes.fontSize3,
        lineHeight: lineHeights_1.lineHeights.lineHeight3,
        letterSpacing: letterSpacing_1.letterSpacing.letterSpacing0,
    },
    lBodySMBold: {
        fontFamily: fontFamilies_1.fontFamilies.euclidCircularB,
        fontWeight: fontWeights_1.fontWeights.bold,
        fontSize: fontSizes_1.fontSizes.fontSize3,
        lineHeight: lineHeights_1.lineHeights.lineHeight3,
        letterSpacing: letterSpacing_1.letterSpacing.letterSpacing0,
    },
    lBodyXS: {
        fontFamily: fontFamilies_1.fontFamilies.euclidCircularB,
        fontWeight: fontWeights_1.fontWeights.regular,
        fontSize: fontSizes_1.fontSizes.fontSize2,
        lineHeight: lineHeights_1.lineHeights.lineHeight2,
        letterSpacing: letterSpacing_1.letterSpacing.letterSpacing1,
    },
    lBodyXSMedium: {
        fontFamily: fontFamilies_1.fontFamilies.euclidCircularB,
        fontWeight: fontWeights_1.fontWeights.medium,
        fontSize: fontSizes_1.fontSizes.fontSize2,
        lineHeight: lineHeights_1.lineHeights.lineHeight2,
        letterSpacing: letterSpacing_1.letterSpacing.letterSpacing1,
    },
};
//# sourceMappingURL=typography.js.map